import { css } from '@emotion/css';

export const formatNumber2point = (number) => {
    return parseFloat(number).toFixed(2);
}

export const checkNaN = (value) => {
    if (isNaN(value)) {
        return 0
    } else {
        return value
    }
}

export const tableCSS = css({
    backgroundColor: 'white',
    '& table': {
        borderCollapse: 'collapse'
    },
    '& thead > tr': {
        borderWidth: '1px',
        borderColor: 'black',
        borderStyle: 'solid',
        backgroundColor: "blue"
    },
    '.ant-table-thead .ant-table-cell':
    {
        backgroundColor: '#00BA9E ',
        color: 'white ',
        borderRadius: 'unset !important '
    },
    '.ant-table-cell:hover':
    {
        cursor: 'pointer'
    },
    '.ant-table-tbody .ant-table-cell':
    {
        textAlign: 'center'
    }
});

export const billtableCSS = css({
    backgroundColor: 'white',
    '& table': {
        borderCollapse: 'collapse'
    },
    '& thead > tr': {
        borderWidth: '1px',
        borderColor: 'black',
        borderStyle: 'solid',
        backgroundColor: "blue"
    },
    '.ant-table-thead .ant-table-cell':
    {
        backgroundColor: 'grey',
        color: 'white ',
        borderRadius: 'unset'
    },
    '.ant-table-cell:hover':
    {
        cursor: 'pointer'
    }
});
